export enum StepStatus {
    wait = 'wait',
    process = 'process',
    finish = 'finish,'
}